<template>
  <div v-if="getIsShowing" id="modal-view" class="modal-view-holder" @click="handleBackgroundClick">
    <div :class="getModalCss" @click="handleMouseDown">
      <ModalPrompt v-show="getModalType === 'prompt'"></ModalPrompt>
      <ModalWarning v-show="getModalType === 'warning'"></ModalWarning>
      <ModalCalculations class="modal-calculations" v-if="getModalType === 'calculations'" @click.stop="" />
      <ModalSettings class="modal-settings" v-if="getModalType === 'settings'" />
      <ModalPipe v-if="getModalType === 'pipe' || getModalType === 'prompt-pipe'" @click.stop="" />
      <ModalGraphSettings v-if="getModalType === 'graph'" @click.stop=""></ModalGraphSettings>
      <ModalSlopeExtend v-if="getModalType === 'slope-extend'" @click.stop=""></ModalSlopeExtend>
      <ModalExcessivePressureDrop v-if="getModalType === 'excessive-pressure-drop'" @click.stop=""></ModalExcessivePressureDrop>
      <TOSModal v-if="getModalType === 'tos'" />
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import ModalSprinklers from '@/modal/ModalSprinklers.vue';
import ModalWarning from '@/modal/ModalWarning.vue';
import ModalCalculations from '@/modal/ModalCalculations.vue';
import ModalSettings from '@/modal/ModalSettings.vue';
import ModalJob from '@/modal/ModalJob.vue';
import ModalPipe from '@/modal/ModalPipe';
import ModalPrompt from '@/modal/ModalPrompt';
import ModalGraphSettings from '@/modal/ModalGraphSettings';
import ModalSlopeExtend from './ModalSlopeExtend.vue';
import ModalExcessivePressureDrop from './ModalExcessivePressureDrop.vue';
import TOSModal from '@/modal/TOSModal';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'ModalView',
  components: {
    ModalPrompt,
    ModalSprinklers,
    ModalCalculations,
    ModalSettings,
    ModalJob,
    ModalPipe,
    ModalGraphSettings,
    ModalWarning,
    ModalSlopeExtend,
    ModalExcessivePressureDrop,
    TOSModal,
  },
  computed: {
    getIsShowing () {
      return useModalStore().getIsShowing;
    },
    getModalType () {
      return useModalStore().getModalType;
    },
    getModalCss () {
      if (this.getModalType === 'prompt') {
        return 'modal-view-bg prompt';
      } else {
        return 'modal-view-bg';
      }
    }
  },
  methods: {
    hideModal () {
      if (this.getModalType === 'sprinklers') { 
        return;
      }
      useModalStore().hideModal();
      if (this.getModalType === 'graph') {
        useSettingsStore().resetGraphSettingsExpansion();
      }
    },
    handleMouseDown () {
      this.hideModal();
    },
    handleBackgroundClick () {
      if (this.getModalType === 'tos' || this.getModalType === 'sprinklers') { return; }
      useModalStore().toggleModal();
      this.hideModal();
    },
  }
};
</script>

<style scoped>
.modal-view-bg {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
}
.modal-sprinklers {
  justify-self: flex-end !important;
}
.prompt {
  align-items: center;
  justify-content: center;
}
.modal-view-holder {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>
